module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/421e794b57e9d8a55f61dea8acbaf122.png";